/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Last_NameInputs */

const en_profile_last_name = /** @type {(inputs: Profile_Last_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last name`)
};

const es_profile_last_name = /** @type {(inputs: Profile_Last_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apellido`)
};

/**
* | output |
* | --- |
* | "Last name" |
*
* @param {Profile_Last_NameInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const profile_last_name = /** @type {((inputs?: Profile_Last_NameInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Last_NameInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_profile_last_name(inputs)
	return en_profile_last_name(inputs)
});